module.exports = __webpack_public_path__ + "img/Fiche-tuteur.d36c2f59.jpg";